import {t} from '@lingui/macro'

import {PlanType} from '~/api/types/plan'

export const isTeamPlan = [PlanType.TEAM, PlanType.BUSINESS]
export const isProOrPremium = [PlanType.PRO, PlanType.PREMIUM]
export const availablePlansForUserToChoose = [PlanType.FREE, PlanType.PRO, PlanType.PREMIUM]
export const availableTeamPlansForUserToChoose = [PlanType.FREE, PlanType.TEAM, PlanType.BUSINESS]
export const availablePlansPreferredOrder: PlanType[] = [
    PlanType.FREE,
    PlanType.PRO,
    PlanType.PREMIUM,
]
export const availableTeamPlansPreferredOrder: PlanType[] = [
    PlanType.FREE,
    PlanType.TEAM,
    PlanType.BUSINESS,
]
export const getMappedPlan = (): Record<PlanType, PlanType> => ({
    [PlanType.ESSENTIAL]: PlanType.PRO,
    [PlanType.PRO]: PlanType.PRO,
    [PlanType.PREMIUM]: PlanType.PREMIUM,
    [PlanType.YEARLY]: PlanType.PREMIUM,
    [PlanType.LEGACY]: PlanType.PRO,
    [PlanType.EXTRA]: PlanType.PRO,
    [PlanType.YEARLY_EXTRA]: PlanType.PREMIUM,
    [PlanType.PARTNERSHIP]: PlanType.PRO,
    [PlanType.MANAGING_PARTNER]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_5]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_10]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_15]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_20]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_25]: PlanType.PREMIUM,
    [PlanType.PARTNER_CLIENT_FREE]: PlanType.FREE,
    [PlanType.PARTNER_CLIENT_PRO]: PlanType.PRO,
    [PlanType.UNKNOWN]: PlanType.PRO,
    [PlanType.FREE]: PlanType.FREE,
    [PlanType.STARTER]: PlanType.STARTER,
    [PlanType.FIXED_RATE]: PlanType.FIXED_RATE,
    [PlanType.TEAM]: PlanType.TEAM,
    [PlanType.BUSINESS]: PlanType.BUSINESS,
    [PlanType.ADVANCED]: PlanType.ADVANCED,
    [PlanType.INSURANCE]: PlanType.INSURANCE,
})

export const getPlanTypeBenefits = (): Record<PlanType, string[]> => ({
    [PlanType.ESSENTIAL]: [],
    [PlanType.PRO]: [
        t`Reimburse expenses`,
        t`Pay, process and manage invoices`,
        t`Access real-time analytics and insights`,
        t`Create and manage teams`,
        t`Set individual spending limits`,
    ],
    [PlanType.PREMIUM]: [
        t`Unlimited users`,
        t`Custom onboarding`,
        t`Dedicated account manager`,
        t`Business travel insurance (extra cost)`,
    ],
    [PlanType.YEARLY]: [
        t`Unlimited users`,
        t`Custom onboarding`,
        t`Dedicated account manager`,
        t`Business travel insurance (extra cost)`,
    ],
    [PlanType.LEGACY]: [],
    [PlanType.EXTRA]: [],
    [PlanType.YEARLY_EXTRA]: [],
    [PlanType.PARTNERSHIP]: [],
    [PlanType.MANAGING_PARTNER]: [],
    [PlanType.MANAGING_PARTNER_5]: [],
    [PlanType.MANAGING_PARTNER_10]: [],
    [PlanType.MANAGING_PARTNER_15]: [],
    [PlanType.MANAGING_PARTNER_20]: [],
    [PlanType.MANAGING_PARTNER_25]: [],
    [PlanType.PARTNER_CLIENT_FREE]: [],
    [PlanType.PARTNER_CLIENT_PRO]: [],
    [PlanType.UNKNOWN]: [],
    [PlanType.FREE]: [
        t`Virtual and plastic cards`,
        t`Automated expense reports`,
        t`Automatically fetch email receipts`,
        t`Manage out-of-pocket expenses`,
    ],
    [PlanType.STARTER]: [],
    [PlanType.FIXED_RATE]: [],
    [PlanType.TEAM]: [
        t`Reimburse expenses`,
        t`Pay, process and manage invoices`,
        t`Access real-time analytics and insights`,
        t`Create and manage teams`,
        t`Set individual spending limits`,
    ],
    [PlanType.BUSINESS]: [
        t`Unlimited users`,
        t`Custom onboarding`,
        t`Dedicated account manager`,
        t`Business travel insurance (extra cost)`,
    ],
    [PlanType.ADVANCED]: [],
    [PlanType.INSURANCE]: [],
})

export const getPlanTypeAmountInfo = (): Record<PlanType, string> => ({
    [PlanType.ESSENTIAL]: '',
    [PlanType.PRO]: t`per user per month`,
    [PlanType.PREMIUM]: t`per user per month`,
    [PlanType.YEARLY]: t`per user per month`,
    [PlanType.LEGACY]: '',
    [PlanType.EXTRA]: '',
    [PlanType.YEARLY_EXTRA]: '',
    [PlanType.PARTNERSHIP]: '',
    [PlanType.MANAGING_PARTNER]: '',
    [PlanType.MANAGING_PARTNER_5]: '',
    [PlanType.MANAGING_PARTNER_10]: '',
    [PlanType.MANAGING_PARTNER_15]: '',
    [PlanType.MANAGING_PARTNER_20]: '',
    [PlanType.MANAGING_PARTNER_25]: '',
    [PlanType.PARTNER_CLIENT_FREE]: '',
    [PlanType.PARTNER_CLIENT_PRO]: '',
    [PlanType.UNKNOWN]: '',
    [PlanType.FREE]: t`for up to 5 users`,
    [PlanType.STARTER]: '',
    [PlanType.FIXED_RATE]: '',
    [PlanType.TEAM]: t`per user per month`,
    [PlanType.BUSINESS]: t`no user commitment`,
    [PlanType.ADVANCED]: '',
    [PlanType.INSURANCE]: '',
})

export const getPlanNameCamelCase = (): Record<PlanType, string> => ({
    [PlanType.ESSENTIAL]: '',
    [PlanType.PRO]: t`Pro`,
    [PlanType.PREMIUM]: t`Premium`,
    [PlanType.YEARLY]: t`Premium`,
    [PlanType.LEGACY]: '',
    [PlanType.EXTRA]: '',
    [PlanType.YEARLY_EXTRA]: '',
    [PlanType.PARTNERSHIP]: '',
    [PlanType.MANAGING_PARTNER]: '',
    [PlanType.MANAGING_PARTNER_5]: '',
    [PlanType.MANAGING_PARTNER_10]: '',
    [PlanType.MANAGING_PARTNER_15]: '',
    [PlanType.MANAGING_PARTNER_20]: '',
    [PlanType.MANAGING_PARTNER_25]: '',
    [PlanType.PARTNER_CLIENT_FREE]: '',
    [PlanType.PARTNER_CLIENT_PRO]: '',
    [PlanType.UNKNOWN]: '',
    [PlanType.FREE]: t`Free`,
    [PlanType.STARTER]: t`Starter`,
    [PlanType.FIXED_RATE]: '',
    [PlanType.TEAM]: t`Team`,
    [PlanType.BUSINESS]: t`Business`,
    [PlanType.ADVANCED]: t`Advanced`,
    [PlanType.INSURANCE]: '',
})
